// extracted by mini-css-extract-plugin
export default {"ShieldIcon":"BranchProtectionShield-module__ShieldIcon__lxfJY6n"};